import React from 'react';

interface EmptyStateCardProps {
  message: string;
  icon?: React.ReactNode;
}

const EmptyStateCard: React.FC<EmptyStateCardProps> = ({ message, icon }) => {
  return (
    <div
      style={{
        backgroundColor: 'white',
        borderRadius: '6px',
        padding: '24px 16px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        color: '#6b7280',
        minHeight: '120px',
      }}
    >
      {icon && <div style={{ marginBottom: '8px', fontSize: '24px' }}>{icon}</div>}
      <p style={{ margin: 0, fontSize: 'medium', fontWeight: 'bold', color: '#005A9C' }}>{message}</p>
    </div>
  );
};

export default EmptyStateCard;
